import { useState, useEffect } from 'react';
import { useLocalStorage } from './hooks/useLocalStorage';

/**
 * Verwaltet Klassen-Namen und IDs für YOLO-Labels
 */
export const useClassManager = (initialClasses = []) => {
    const [classes, setClasses] = useLocalStorage('app_classes', initialClasses);

    // Füge eine neue Klasse hinzu
    const addClass = (className) => {
        if (!className || className.trim() === '') return;
        const newClass = {
            id: classes.length,
            name: className.trim()
        };
        setClasses([...classes, newClass]);
        return newClass.id;
    };

    // Entferne eine Klasse
    const removeClass = (classId) => {
        const newClasses = classes.filter(c => c.id !== classId);
        // Aktualisiere IDs
        const updatedClasses = newClasses.map((c, index) => ({
            ...c,
            id: index
        }));
        setClasses(updatedClasses);
    };

    // Ändere den Namen einer Klasse
    const updateClassName = (classId, newName) => {
        setClasses(classes.map(c => 
            c.id === classId ? { ...c, name: newName.trim() } : c
        ));
    };

    // Hole Klassen-ID nach Name
    const getClassId = (className) => {
        const found = classes.find(c => c.name === className);
        return found ? found.id : null;
    };

    // Hole Klassen-Name nach ID
    const getClassName = (classId) => {
        const found = classes.find(c => c.id === classId);
        return found ? found.name : null;
    };

    // Exportiere Klassen als Array von Strings (für classes.txt)
    const exportClasses = () => {
        return classes.map(c => c.name);
    };

    // Importiere Klassen aus Array von Strings
    const importClasses = (classNames) => {
        const importedClasses = classNames.map((name, index) => ({
            id: index,
            name: name.trim()
        }));
        setClasses(importedClasses);
    };

    return {
        classes,
        addClass,
        removeClass,
        updateClassName,
        getClassId,
        getClassName,
        exportClasses,
        importClasses
    };
};

/**
 * Standard-Klassen-Manager Hook mit Default-Klassen
 */
export const useDefaultClassManager = () => {
    return useClassManager([
        { id: 0, name: 'object' },
        { id: 1, name: 'label' }
    ]);
};

